module.exports = __webpack_public_path__ + "static/media/m2.a99a9aa2.png";